import * as React from 'react';

import Button from 'components/ButtonDeprecated';
import Heading from 'components/Heading';
import Image from 'components/Image';
import Link from 'components/Link';
import Row from 'components/Row';
import Text from 'components/Text';
import LinkConstants from 'constants/LinkConstants';

export default function AdminSisSyncSchoolNotSetup() {
  return (
    <Heading align="center">
      <Row size="small">
        <Text align="center" size="xxlarge">
          Synchronize Remind with your SIS
        </Text>
      </Row>
      <Row size="xxxlarge">
        <Text align="center" size="medium">
          Automatically create accounts and classes in Remind.{' '}
          <Link target="_blank" href={LinkConstants.ROSTERING_GUIDE}>
            Learn more
          </Link>
        </Text>
      </Row>
      <Row>
        <Image full src={require('assets/images/admin/AdminSisSyncSchoolNotSetup/banner.svg')} />
      </Row>
      <Row>
        <Text align="center" size="medium">
          Ready to set up SIS sync?
        </Text>
      </Row>
      <Button href={LinkConstants.CONTACT_FORM} level="secondary">
        Contact our Support Team
      </Button>
    </Heading>
  );
}
